import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import ImageHead from '../assets/svg/hydra_score_head_sm.webp'
import { useNavigate } from 'react-router-dom'
import { callAPI } from '../hooks/api'
import Spinner from '../components/Spinner'
import { FaLinkedinIn, FaYoutube, FaFacebookF } from 'react-icons/fa'
import { siteConfig } from '@/config/site'

export default function ForgotPassword({ currentTab, setCurrentTab }) {
  setCurrentTab('forgot-password')
  const removeStylesheet = (href) => {
    const link = document.querySelector(`link[href="${href}"]`)
    if (link) {
      document.body.removeChild(link)
    }
  }
  removeStylesheet('/css/landing.css')
  removeStylesheet('/css/bootstrap.css')

  const [formData, setFormData] = useState({
    email: '',
  })

  const [loading, setLoading] = useState(false)
  const { email } = formData
  const navigate = useNavigate()

  const localAuth = localStorage.getItem('auth')
    ? JSON.parse(localStorage.getItem('auth'))
    : {}

  useEffect(() => {
    if (localAuth.sessionKey === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf') {
      localStorage.setItem('auth', JSON.stringify({}))
    } else if (Object.keys(localAuth).length) {
      navigate('/')
    }
  }, [localAuth])

  function onChange(e) {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }))
  }

  async function sendPasswordResetEmail(email) {
    if (!email) {
      setLoading(false)
      throw new Error('The required field is empty.')
    }
    var endpoint = '/forgot_password'

    var params = {
      email: email,
    }
    return await callAPI(endpoint, params)
  }

  async function onSubmit(e) {
    e.preventDefault()
    try {
      setLoading(true)
      var res = await sendPasswordResetEmail(email)
      setLoading(false)
      if (res.status === 'fail') {
        toast.warn(res.msg)
      } else if (res.status === 'success') {
        toast.success(res.msg)
        navigate('/sign-in')
      } else {
        toast.warn(
          'Something went wrong on the server side. Please try again later'
        )
        navigate('/sign-in')
      }
    } catch (error) {
      toast.warn(error.message)
    }
  }
  const handleIconClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <section className="splash-icon" style={{ minHeight: '673px' }}>
      {loading && <Spinner />}
      <div className="signin-box">
        <div className="flex justify-center flex-wrap items-center px-6 py-12 max-w-2xl mx-auto bg-white rounded">
          <div className="w-full md:w-[87%] lg:w-[72%]">
            <div
              className="items-center w-full flex flex-col"
              style={{ padding: '1em 1em' }}
            >
              <a href={siteConfig.landingUrl}>
                <img src={ImageHead} alt="Head" />
              </a>
              <h1 className="text-3xl text-center mt-4 mb-0 font-bold">
                Forgot Password
              </h1>
            </div>
            <form onSubmit={onSubmit}>
              <input
                className="mb-6 w-full px-4 py-2 mt-4 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                type="email"
                id="email"
                value={email}
                onChange={onChange}
                placeholder="Email address"
              />
              <button
                className="w-full h-12 bg-primary text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-[#01589d] transition duration-150 ease-in-out hover:shadow-lg active:bg-primary "
                type="submit"
              >
                Send Reset Password
              </button>
              <hr className="my-6" />
              <button
                className="w-full h-12 bg-gray-200 text-gray-700 px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-gray-300 transition duration-150 ease-in-out hover:shadow-lg active:bg-gray-400"
                onClick={() => {
                  navigate('/sign-in')
                }}
              >
                Back
              </button>
            </form>
          </div>
        </div>
        <div className="mt-6 text-center">
          <p className="text-gray-400 mb-4">
            Hydra Score™ is a precision water and land data analytics platform.
          </p>
          <div className="flex justify-center space-x-4">
            <FaFacebookF
              style={{
                width: '20px',
                height: '20px',
                color: 'gray',
                cursor: 'pointer',
                borderRadius: '4px',
              }}
              onClick={() =>
                handleIconClick(
                  'https://www.facebook.com/profile.php?id=61560861611781'
                )
              }
            />
            <FaYoutube
              style={{
                width: '20px',
                height: '20px',
                color: 'gray',
                cursor: 'pointer',
                borderRadius: '4px',
              }}
              onClick={() =>
                handleIconClick(
                  'https://www.youtube.com/channel/UCOfzLw8uh-KvxDKqDjsmBzA'
                )
              }
            />
            <FaLinkedinIn
              style={{
                width: '20px',
                height: '20px',
                color: 'gray',
                cursor: 'pointer',
                borderRadius: '4px',
              }}
              onClick={() =>
                handleIconClick(
                  'https://www.linkedin.com/company/hydra-score/about/?viewAsMember=true'
                )
              }
            />
          </div>
        </div>
      </div>
    </section>
  )
}
